import React from "react";
import styled from "styled-components";
import { Card, Row, Col, Statistic, Typography } from "antd";
import { ShoppingOutlined, FileTextOutlined, UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const PulseCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  .ant-card-body {
    padding: 20px;
  }
`;

const WeakestLink = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: ${props => {
    if (props.$severity === "high") return "#fff1f0";
    if (props.$severity === "medium") return "#fffbe6";
    return "#f6ffed";
  }};
  border-left: 3px solid ${props => {
    if (props.$severity === "high") return "#ff4d4f";
    if (props.$severity === "medium") return "#faad14";
    return "#52c41a";
  }};
  border-radius: 4px;
`;

const TodaysPulse = ({ 
  newOrders = 0, 
  newQuotes = 0, 
  newLeads = 0 
}) => {
  // Identify the weakest link (bottleneck)
  const getWeakestLink = () => {
    const ratios = {
      quotesToLeads: newLeads > 0 ? newQuotes / newLeads : 0,
      ordersToQuotes: newQuotes > 0 ? newOrders / newQuotes : 0,
    };

    if (ratios.quotesToLeads < 0.5 && newLeads > 5) {
      return {
        message: "Quoting bottleneck detected",
        description: `Many leads (${newLeads}) but few quotes (${newQuotes}). Focus on quote generation.`,
        severity: "high",
      };
    }

    if (ratios.ordersToQuotes < 0.3 && newQuotes > 3) {
      return {
        message: "Conversion bottleneck",
        description: `Quotes sent (${newQuotes}) but few orders (${newOrders}). Follow up on pending quotes.`,
        severity: "medium",
      };
    }

    if (newLeads === 0 && newQuotes === 0 && newOrders === 0) {
      return {
        message: "No activity today",
        description: "Consider reviewing lead generation channels.",
        severity: "low",
      };
    }

    return null;
  };

  const weakestLink = getWeakestLink();

  return (
    <PulseCard title="Today's Pulse">
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Statistic
            title="New Leads"
            value={newLeads}
            prefix={<UserOutlined />}
            valueStyle={{ color: "#1890ff" }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="New Quotes"
            value={newQuotes}
            prefix={<FileTextOutlined />}
            valueStyle={{ color: "#faad14" }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="New Orders"
            value={newOrders}
            prefix={<ShoppingOutlined />}
            valueStyle={{ color: "#005249" }}
          />
        </Col>
      </Row>

      {weakestLink && (
        <WeakestLink $severity={weakestLink.severity}>
          <Text strong style={{ display: "block", marginBottom: 4 }}>
            {weakestLink.message}
          </Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {weakestLink.description}
          </Text>
        </WeakestLink>
      )}
    </PulseCard>
  );
};

export default TodaysPulse;

